import React from 'react';
import './style.css';

function Footer() {
      return (
            <footer className="footer py-3" id="footer-items">
                  <div className="container text-center">

                        <h5 className="footer-text">
                              &copy; Mirza Abdul Awal, 2021, All Rights Reserved.
                        </h5>
                  </div>
            </footer>
      )
}

export default Footer;